const KEY = 'apollo-room-look';

export const saveLook = (look) => {
  try { sessionStorage.setItem(KEY, JSON.stringify(look)); } catch { /* ignore */ }
};

export const readLook = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch { return null; }
};

export const clearLook = () => { try { sessionStorage.removeItem(KEY); } catch { /* ignore */ } };

export const lookSummary = (look) => {
  if (!look) return '';
  const parts = [`${look.fabric_name} (${look.fabric_code})`, look.material_name, look.collection_name].filter(Boolean);
  const light = look.light_mode === 'screen' ? `${look.light_label} ${look.openness}% openness` : look.light_label;
  return `Room Preview look: ${parts.join(' · ')} — ${light}, shown in ${look.room_name}${look.ambience === 'night' ? ' (night view)' : ''}, shade ${Math.round((look.drop ?? 0.5) * 100)}% lowered.`;
};
